interface LoaderProps {

    /** Custom CSS classes for the spinner (usually for border colors) */
    classes?: string;

    /** The height of the outer container (Tailwind h-{value} scale) */
    height?: number;

    /** The width and height of the spinner itself (Tailwind w-{value} h-{value} scale) */
    size?: number;
}

export const Loader = ({ classes = 'border-foreground', height = 40, size = 16 }: LoaderProps) => {
    return (
        <div className={ `flex items-center justify-center h-${ height }` }>
            <div className={ `${ classes } w-${ size } h-${ size } border-t-4 border-b-4 rounded-full animate-spin` }></div>
        </div>
    );
};
